module.exports = __webpack_public_path__ + "static/media/EstablishingMLWorkflow.3fa0ac0b.png";